import React from "react"
import styled from 'styled-components'
import { breakpoints, colors, sizes, mixins} from './../css-variables'
import CategoryList from '../atoms/CategoryList'
import SeparatorLine from "../atoms/SeparatorLine"

const IntroSummary = ({className, title, categories, timeToRead, date, modified, taxContentTypes}) => {

  const newDate = new Date();
      let twoWeeksAgo = newDate - 1000 * 60 * 60 * 24 * 14
      let oneMonthAgo = newDate - 1000 * 60 * 60 * 24 * 30
      const isNewModified = new Date(date).getTime() > new Date(twoWeeksAgo).getTime() ? 'New' : new Date(modified).getTime() > new Date(oneMonthAgo).getTime() ? 'Updated' : null

  return (
    <div className={`${className} resourceIntro max-width-wrap`}>
      <div className="fixedSizeWrap">
        {taxContentTypes?.nodes?.[0]?.name && (
          <div className='contentType'>{taxContentTypes.nodes[0].name}{isNewModified && (<span>{isNewModified}</span>)}</div>
        )}
          
          <h1 className='resourceTitle'>{title}</h1>
          <SeparatorLine />
          <div className='categoryTimeContainer'>
            {categories && (
              <CategoryList categories={categories} />
            )}
            {timeToRead && timeToRead.timeToRead && (
              <div className='readtime'>| {timeToRead.timeToRead} minute{timeToRead?.timeToRead > 1 ? 's' : ''} to read</div>
            )}
          </div>
          {modified && (
            <div className='lastupdated'>Last Updated: {modified}</div>
          )}
      </div>
        
    </div>
  )
}
const StyledIntroSummary = styled(IntroSummary)` 
  flex: 0 0 100%;
  background-color: ${colors.bgGrey};
  width: 100%;
  padding: 0 auto;
  margin-bottom: 48px !important;
  @media screen and ${breakpoints.laptopS} {
    padding-left: 24px;
  }

  .fixedSizeWrap{
    ${mixins.fixed_width_element}
    padding: 24px 24px 48px 24px;
    ${mixins.fixed_width_content_pad}
    padding-top: ${sizes.s24};
    padding-bottom: ${sizes.s48};
  }

  .categoryTimeContainer{
    margin-top: 18px;
    margin-bottom: 12px;
    margin-right: 4px;
    position: relative;
    font-weight: 500;

    div{
      display: inline-block;
      &:first-child {
        margin-left: 0;
        padding-left: 0;
      }

    }
  }
  .contentType{
    margin-bottom: 12px;
    ${mixins.card_label}
    span{
      color:${colors.mainRed};
      padding-left: 8px;
      border-left: 2px solid ${colors.textGrey};
      margin-left: 8px;
    }
  }
  .resourceTitle{
    margin-top: 0px;
    margin-bottom: 18px;
  }
  .readtime{

  }
  .lastupdated{
  }
` 
export default StyledIntroSummary

